export const translations = {
  ko: {
    nav: {
      home: 'Home',
      about: 'About',
      certifications: 'Certifications',
      skills: 'Skills',
      projects: 'Projects',
      contact: 'Contact',
    },
    hero: {
      name: '오성원',
      role1: 'CS Student',
      role2: 'Web · Application · AI Engineer',
      description: '불가능이란 없습니다. 문제를 마주하면 해결책을 찾고, 아이디어가 있으면 현실로 만듭니다.',
      btnPortfolio: '포트폴리오 보기',
      btnContact: '연락하기',
      visitors: (n) => `오늘 이 포트폴리오에 관심 있는 사람은 ${n}명 입니다.`,
    },
    about: {
      label: 'About Me',
      title: '저를 소개합니다',
      intro: '컴퓨터전자공학을 전공하며 HW, SW 경계를 넘나드는 개발에 관심을 갖게 되었습니다. 최근 이슈인 AI와 IoT 기술을 접목시킨 기기들을 만들며 눈에 보이는 결과물에 재미를 느꼈고, AI를 두려움의 대상이 아닌 나를 강화해줄 개인 에이전트이자 도구로 활용하며 상상을 현실로 만들어가고 있습니다. 새로운 기술을 직접 부딪히며 배우는 것을 좋아합니다.',
      strengths: [
        {
          title: '도전',
          description: '남들이 하는 \'불가능\'이라는 말에 흔들리지 않습니다. 남들이 피하는 문제일수록 해결하면 제게 돌아오는 희열, 성취감은 힘듦을 잊게 하고, 불가능에 도전하게 만드는 이유라고 생각합니다.',
        },
        {
          title: '끈기',
          description: '내가 원하는 결과가 나올 때까지 손을 놓지 않습니다. 코드 한 줄, 회로 하나까지 원인을 찾고 파고들며, 실패는 멈출 이유가 아니라 배움이고 다음을 위한 선행학습이라고 생각합니다.',
        },
        {
          title: '호기심',
          description: '궁금한 게 생기거나 필요한 게 생기면 직접 만들며 배움을 일상에도 적용시키는 개발자입니다. 제가 뭘 할 수 있을지, 어떤 걸 만들 수 있을지 궁금하지 않으세요?',
        },
        {
          title: '자신감',
          description: '결과를 예상할 수 없어도 일단 시도합니다. 처음 해보는 기술이라도 \'성공한다\'라는 확신을 가지고 부딪힙니다. 그 확신이 결국 결과로 이어지는 경험을 여러 번 쌓아왔고, 항상 마지막에는 웃음을 보였던 기억이 남아있습니다.',
        },
      ],
    },
    certifications: {
      label: 'Certifications',
      title: '자격증',
      othersTitle: '기타 자격증',
      upcoming: '취득 예정',
      showMore: '더보기',
      showLess: '접기',
    },
    skills: {
      label: 'Skills',
      title: '다루는 기술',
      legendTitle: '레벨 안내',
      levels: [
        '사용만 해봤음',
        '간단한 기능을 구현할 수 있음',
        '프로젝트에 활용할 수 있음',
        '능숙하게 다룸',
        '깊이 이해하고 있음',
      ],
    },
    projects: {
      label: 'Projects',
      title: '프로젝트',
      github: 'GitHub',
      demo: 'Demo',
      preview: 'Preview',
      previewClose: '닫기',
      previewPrev: '이전 화면',
      previewNext: '다음 화면',
      descriptions: {
        todayapp: '위치 기반 관광지 추천과 실시간 채팅을 하나로 묶은 안드로이드 앱입니다. 사용자의 GPS 좌표로 지역을 판별해 관광지를 추천하고, 같은 장소를 선택한 사람들이 좌표 기반 고유 채팅방에서 자연스럽게 만나 소통할 수 있게 만들었습니다. 이메일 인증 전까지는 임시 계정으로만 취급하는 Firebase Auth 인증 흐름을 직접 설계했고, 비활성 채팅방과 미인증 계정은 Cloud Functions가 자동으로 정리하도록 해 별도 관리 없이도 안정적으로 운영되도록 했습니다.',
        turret: '웹캠 영상에서 YOLOv8과 얼굴 인식으로 특정 인물을 실시간으로 골라내고, 화면 중심과의 오차를 시리얼 통신으로 아두이노에 전달해 서보모터가 대상을 부드럽게 따라가도록 만든 프로젝트입니다. 절대 각도가 아닌 상대 각도로 서보를 제어해 추적이 끊기지 않도록 했고, 조준 상태가 3초 이상 유지되면 자동으로 발사 신호를 보내도록 구현했습니다.',
        gesture: 'MediaPipe로 손가락 개수를 실시간으로 인식해 블루투스로 아두이노에 신호를 보내고, 인식된 제스처에 따라 LED·모터·부저·LCD를 각각 다르게 반응시키는 시스템입니다. 손이 화면에서 사라져 신호가 1초 이상 끊기면 별도의 정지 명령 없이도 자동으로 초기 상태로 복귀하도록 설계해, 손을 떼는 것만으로 안전하게 멈추도록 했습니다.',
        localcoder: 'Qwen2.5-Coder 모델을 한국어 코드 어시스턴트로 직접 LoRA 파인튜닝하고 Ollama로 배포한 로컬 AI 에이전트입니다. FastAPI로 인증과 요청 제한을 갖춘 웹 서버를 구축해 GPU 자원이 함부로 소모되지 않도록 했고, Cloudflare Tunnel로 실제 도메인에 연결해 로컬 환경을 벗어나 어디서든 접속할 수 있는 서비스 형태로 완성했습니다.',
        workout: 'SwiftUI로 만든 iOS 운동 기록 앱입니다. 운동 기록을 근육별 회복 속도로 감쇠시키는 피로도 모델과, 하나의 운동이 주동근·협응근에 주는 자극을 가중치로 분해하는 매핑 엔진을 직접 설계해 "지금 어느 부위가 얼마나 지쳤는지"를 인체 그림으로 보여줍니다. 홈·잠금화면 위젯과 다이나믹 아일랜드로 앱 밖에서도 회복 상태를 확인할 수 있고, 인바디 CSV를 불러와 체성분 변화를 4분면으로 분석하도록 했습니다. 외부 라이브러리 없이 순수 Apple 프레임워크만 사용했으며, SwiftUI와 앱 아키텍처를 직접 익히기 위한 학습용으로 제작한 프로젝트입니다.',
        portfolio: '지금 보고 계신 이 사이트입니다. React로 직접 만든 싱글페이지 포트폴리오로, 한국어·영어·일본어 3개 언어를 실시간으로 전환하는 다국어 시스템과 섹션 단위 풀스크린 스크롤을 구현했습니다. 프로젝트·기술·자격증 데이터를 컴포넌트에서 분리해 관리하도록 설계했고, 완성된 사이트는 Cloudflare Pages에 배포해 실제 도메인으로 24시간 운영하고 있습니다.',
      },
      captions: {
        todayappHome: '현재 위치를 기준으로 주변 관광지를 거리순으로 추천합니다.',
        todayappCategory: '맛집·드라이브·문화 등 카테고리를 선택해 추천 결과를 바꿉니다.',
        todayappLocation: 'GPS 좌표를 위경도 범위와 대조해 현재 지역을 판별합니다.',
        todayappActiveRoom: '최근 대화가 있었던 장소에는 활발한 채팅방 배지가 표시됩니다.',
        todayappChatRoom: '같은 장소를 선택한 사용자들이 모이는 채팅방과 실시간 참여자 수입니다.',
        todayappChatSend: '메시지를 주고받으면 모든 참여자 화면에 실시간으로 반영됩니다.',
        todayappEmailVerify: '이메일 인증 링크 전송 후 남은 시간을 실시간으로 표시합니다.',
        todayappProfile: '로그인한 사용자의 닉네임과 계정 정보를 확인할 수 있습니다.',
        workoutHome: '이번 주 부족한 부위를 분석해 오늘의 추천 플랜을 보여줍니다.',
        workoutPlanSelect: '빈 플랜으로 즉석 시작하거나, 저장해둔 플랜 중 하나를 골라 운동을 시작합니다.',
        workoutFatigueMap: '근육별 회복 속도로 감쇠시킨 피로도를 인체 그림 위에 부위별로 표시합니다.',
        workoutVolumeRadar: '기간별 부위별 운동 볼륨을 레이더 차트로 비교해 균형을 확인합니다.',
        workoutSession: '세트마다 무게·횟수를 기록하며 실시간 타이머로 휴식 시간을 관리합니다.',
        workoutAiCoach: '운동별 핵심 자세와 흔한 실수, 템포·휴식 기준을 AI 코치가 알려줍니다.',
        workoutInbodyHistory: '인바디 CSV를 불러와 체중·골격근·체지방 변화를 날짜별로 기록합니다.',
        workoutInbodyCoach: '최근 측정값의 변화를 분석해 다음 방향을 제안하는 AI 코치 코멘트입니다.',
      },
    },
    contact: {
      label: 'Contact',
      title: '연락처',
      intro: '새로운 기회나 협업 제안은 언제든 환영합니다.',
      email: 'Email',
      copied: '복사되었습니다!',
      github: 'GitHub',
    },
    footer: {
      copyright: '© 2026 오성원. All rights reserved.',
      email: 'Email',
    },
    chatbot: {
      windowTitle: 'OSW Bot',
      greeting: '안녕하세요! 오성원에 대해 궁금한 점을 물어보세요.',
      placeholder: '메시지를 입력하세요...',
      send: '전송',
      defaultReply: '아직 배우는 중인 챗봇이라 정확히 답하지 못했어요. 곧 더 똑똑해질 예정입니다!',
      scriptedReplies: [
        {
          keywords: ['이름', '누구'],
          reply: '저는 오성원입니다. 컴퓨터전자공학을 전공하는 학생 개발자예요.',
        },
        {
          keywords: ['프로젝트'],
          reply: '아두이노/라즈베리파이 기반 IoT 프로젝트, React 웹 프로젝트, AI 프로젝트를 진행했어요. 아래 Projects 섹션에서 확인해보세요!',
        },
        {
          keywords: ['기술', '스킬', 'skill'],
          reply: 'Frontend, AI, Embedded Systems, Database & Backend, Cloud 등 다양한 기술을 다루고 있어요. Skills 섹션을 확인해보세요!',
        },
        {
          keywords: ['연락', 'contact', '이메일'],
          reply: 'Contact 섹션에서 이메일과 GitHub 링크를 확인하실 수 있어요.',
        },
      ],
    },
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About',
      certifications: 'Certifications',
      skills: 'Skills',
      projects: 'Projects',
      contact: 'Contact',
    },
    hero: {
      name: 'Oh Seongwon',
      role1: 'CS Student',
      role2: 'Web · Application · AI Developer',
      description: 'Nothing is impossible. When I face a problem, I find a solution — when I have an idea, I make it real.',
      btnPortfolio: 'View Portfolio',
      btnContact: 'Contact Me',
      visitors: (n) => `${n} ${n === 1 ? 'person has' : 'people have'} shown interest in this portfolio today.`,
    },
    about: {
      label: 'About Me',
      title: 'Introducing Myself',
      intro: 'Majoring in Computer & Electronics Engineering, I became interested in development that crosses the boundary between hardware and software. Building devices that combine AI and IoT — two of today\'s hottest fields — gave me the thrill of seeing tangible results. Rather than treating AI as something to fear, I use it as my own personal agent and tool that strengthens me, turning imagination into reality. I love learning new technologies by diving straight in.',
      strengths: [
        {
          title: 'Challenge',
          description: 'I don\'t let the word \'impossible\' shake me. The problems others avoid are exactly the ones worth solving — the thrill and sense of achievement that comes from solving them makes me forget the hardship and pushes me to keep taking on the impossible.',
        },
        {
          title: 'Persistence',
          description: 'I don\'t let go until I get the result I want. I dig into the cause down to a single line of code or a single circuit, and I see failure not as a reason to stop, but as learning — a head start on what comes next.',
        },
        {
          title: 'Curiosity',
          description: 'Whenever something sparks my curiosity or a need comes up, I build it myself and apply what I learn to everyday life. Curious what I can do, or what I can build?',
        },
        {
          title: 'Confidence',
          description: 'I try first, even when I can\'t predict the outcome. Even with a technology I\'m using for the first time, I dive in with the conviction that I \'will succeed.\' That conviction has led to real results many times over, and I always remember ending up with a smile.',
        },
      ],
    },
    certifications: {
      label: 'Certifications',
      title: 'Certifications',
      othersTitle: 'Other Certifications',
      upcoming: 'Upcoming',
      showMore: 'Show more',
      showLess: 'Show less',
    },
    skills: {
      label: 'Skills',
      title: 'Skills',
      legendTitle: 'Level Guide',
      levels: [
        'Just tried it',
        'Can implement simple features',
        'Can use it in projects',
        'Comfortable working with it',
        'Deep understanding',
      ],
    },
    projects: {
      label: 'Projects',
      title: 'Projects',
      github: 'GitHub',
      demo: 'Demo',
      preview: 'Preview',
      previewClose: 'Close',
      previewPrev: 'Previous screen',
      previewNext: 'Next screen',
      descriptions: {
        todayapp: "An Android app that combines location-based tourist attraction recommendations with real-time chat. It determines the user's region from GPS coordinates to recommend nearby attractions, and lets people who picked the same place meet and chat naturally in a coordinate-based chat room unique to that spot. I designed the Firebase Auth flow myself so accounts are treated as temporary until email verification, and had Cloud Functions automatically clean up inactive chat rooms and unverified accounts so the app runs reliably without extra maintenance.",
        turret: "A project that uses YOLOv8 and face recognition on webcam video to pick out a specific person in real time, then sends the offset from the frame center to an Arduino over serial so a servo motor smoothly tracks the target. I controlled the servo with relative rather than absolute angles so tracking never stutters, and implemented an automatic fire signal once the aim has been held steady for more than 3 seconds.",
        gesture: "A system that recognizes the number of raised fingers in real time with MediaPipe and sends the signal to an Arduino over Bluetooth, triggering a different response from the LED, motor, buzzer, and LCD depending on the recognized gesture. I designed it so that if the hand disappears from frame and the signal drops for more than a second, the system automatically returns to its initial state without a separate stop command — so simply removing your hand stops it safely.",
        localcoder: "A local AI agent built by LoRA fine-tuning the Qwen2.5-Coder model into a Korean-language code assistant and deploying it with Ollama. I built a FastAPI web server with authentication and rate limiting so the GPU can't be consumed carelessly, and connected it to a real domain via Cloudflare Tunnel to finish it as a service reachable from anywhere, not just the local machine.",
        workout: 'An iOS workout-logging app built with SwiftUI. I designed a fatigue model that decays workout history by each muscle\'s own recovery rate, plus a mapping engine that breaks down how much a given exercise stimulates the primary and assisting muscles, and used them to show "which part is fatigued right now, and how much" on a body diagram. Home and lock-screen widgets plus the Dynamic Island let you check recovery status without opening the app, and it can import an InBody CSV to analyze body-composition changes across four quadrants. It uses only native Apple frameworks with no external libraries, and was built as a learning project to get hands-on with SwiftUI and app architecture.',
        portfolio: "This is the very site you're looking at. A single-page portfolio built from scratch with React, featuring a multilingual system that switches between Korean, English, and Japanese in real time, along with section-by-section full-screen scrolling. I designed the project, skills, and certification data to be managed separately from the components, and deployed the finished site to Cloudflare Pages, where it runs around the clock on a real domain.",
      },
      captions: {
        todayappHome: 'Recommends nearby attractions sorted by distance from your current location.',
        todayappCategory: 'Switching categories — food, driving, culture — changes the recommendations.',
        todayappLocation: 'GPS coordinates are matched against latitude/longitude ranges to identify the region.',
        todayappActiveRoom: 'Places with recent conversations are marked with an active chat room badge.',
        todayappChatRoom: 'A chat room where users who picked the same place gather, with a live participant count.',
        todayappChatSend: 'Messages are reflected on every participant\'s screen in real time.',
        todayappEmailVerify: 'A live countdown shows the time remaining after the verification link is sent.',
        todayappProfile: 'Signed-in users can check their nickname and account details.',
        workoutHome: 'Analyzes which muscle groups were neglected this week and suggests today\'s plan.',
        workoutPlanSelect: 'Start on the fly with an empty plan, or pick one of your saved plans to begin.',
        workoutFatigueMap: 'Shows per-muscle fatigue, decayed by each muscle\'s recovery rate, on a body diagram.',
        workoutVolumeRadar: 'Compares training volume across muscle groups over a period on a radar chart.',
        workoutSession: 'Logs weight and reps for each set while a live timer manages rest periods.',
        workoutAiCoach: 'An AI coach walks through key form cues, common mistakes, and tempo/rest guidelines per exercise.',
        workoutInbodyHistory: 'Imports InBody CSV data and logs weight, skeletal muscle, and body fat changes by date.',
        workoutInbodyCoach: 'An AI coach comment that analyzes recent measurement changes and suggests the next direction.',
      },
    },
    contact: {
      label: 'Contact',
      title: 'Contact',
      intro: 'Always open to new opportunities and collaboration.',
      email: 'Email',
      copied: 'Copied!',
      github: 'GitHub',
    },
    footer: {
      copyright: '© 2026 Oh Seongwon. All rights reserved.',
      email: 'Email',
    },
    chatbot: {
      windowTitle: 'OSW Bot',
      greeting: 'Hi! Ask me anything about Oh Seongwon.',
      placeholder: 'Type a message...',
      send: 'Send',
      defaultReply: 'I\'m still learning, so I couldn\'t answer that precisely. I\'ll get smarter soon!',
      scriptedReplies: [
        {
          keywords: ['name', 'who'],
          reply: 'I\'m Oh Seongwon, a student developer majoring in Computer & Electronics Engineering.',
        },
        {
          keywords: ['project'],
          reply: 'I\'ve worked on Arduino/Raspberry Pi IoT projects, a React web project, and AI projects. Check out the Projects section below!',
        },
        {
          keywords: ['skill', 'tech'],
          reply: 'I work across Frontend, AI, Embedded Systems, Database & Backend, and Cloud. Check out the Skills section!',
        },
        {
          keywords: ['contact', 'email'],
          reply: 'You can find my email and GitHub link in the Contact section.',
        },
      ],
    },
  },

  ja: {
    nav: {
      home: 'Home',
      about: 'About',
      certifications: 'Certifications',
      skills: 'Skills',
      projects: 'Projects',
      contact: 'Contact',
    },
    hero: {
      name: 'Oh Seongwon',
      role1: 'CS Student',
      role2: 'Web · Application · AI Developer',
      description: '不可能はありません。問題に直面したら解決策を見つけ、アイデアがあれば現実にします。',
      btnPortfolio: 'ポートフォリオを見る',
      btnContact: 'お問い合わせ',
      visitors: (n) => `今日このポートフォリオに関心を持った方は ${n} 名です。`,
    },
    about: {
      label: 'About Me',
      title: '自己紹介',
      intro: 'コンピュータ電子工学を専攻し、HWとSWの境界を越える開発に興味を持つようになりました。最近話題のAIとIoT技術を組み合わせた機器を作りながら、目に見える成果に面白さを感じました。AIを恐れるのではなく、自分を強化してくれる個人エージェント兼ツールとして活用し、想像を現実に変えています。新しい技術を自ら体験しながら学ぶことが好きです。',
      strengths: [
        {
          title: '挑戦',
          description: '「不可能」という言葉に揺らぎません。人が避ける問題ほど、解決したときに得られる喜びと達成感が困難さを忘れさせ、不可能に挑む理由になると考えています。',
        },
        {
          title: '粘り強さ',
          description: '望む結果が出るまで手を止めません。コード一行、回路一つに至るまで原因を突き止め、失敗は止まる理由ではなく学びであり、次のための予習だと考えています。',
        },
        {
          title: '好奇心',
          description: '気になることや必要なことがあれば自分で作り、学びを日常にも活かす開発者です。私に何ができるか、何を作れるか気になりませんか?',
        },
        {
          title: '自信',
          description: '結果が予測できなくてもまず挑戦します。初めての技術でも「成功する」という確信を持って取り組みます。その確信が結果につながった経験を何度も積み重ねてきましたし、最後にはいつも笑顔になれた記憶があります。',
        },
      ],
    },
    certifications: {
      label: 'Certifications',
      title: '資格',
      othersTitle: 'その他の資格',
      upcoming: '取得予定',
      showMore: 'もっと見る',
      showLess: '閉じる',
    },
    skills: {
      label: 'Skills',
      title: '扱う技術',
      legendTitle: 'レベルの目安',
      levels: [
        '使ってみた程度',
        '簡単な機能を実装できる',
        'プロジェクトで活用できる',
        '使いこなせる',
        '深く理解している',
      ],
    },
    projects: {
      label: 'Projects',
      title: 'プロジェクト',
      github: 'GitHub',
      demo: 'デモ',
      preview: 'Preview',
      previewClose: '閉じる',
      previewPrev: '前の画面',
      previewNext: '次の画面',
      descriptions: {
        todayapp: '位置情報に基づく観光地レコメンドとリアルタイムチャットを一つにまとめたAndroidアプリです。ユーザーのGPS座標から地域を判別して観光地をおすすめし、同じ場所を選んだ人同士が座標ベースの専用チャットルームで自然に出会い、交流できるようにしました。メール認証が完了するまでは仮アカウントとして扱うFirebase Auth認証フローを自分で設計し、非アクティブなチャットルームと未認証アカウントはCloud Functionsが自動的に整理するようにして、別途管理せずとも安定して運用できるようにしました。',
        turret: 'ウェブカメラの映像からYOLOv8と顔認識で特定の人物をリアルタイムに識別し、画面中心とのズレをシリアル通信でArduinoに送ってサーボモーターが対象を滑らかに追従するようにしたプロジェクトです。絶対角度ではなく相対角度でサーボを制御することで追跡が途切れないようにし、照準状態が3秒以上維持されると自動で発射信号を送るように実装しました。',
        gesture: 'MediaPipeで指の本数をリアルタイムに認識し、Bluetooth経由でArduinoに信号を送り、認識したジェスチャーに応じてLED・モーター・ブザー・LCDをそれぞれ異なる動作で反応させるシステムです。手が画面から消えて信号が1秒以上途絶えると、別途の停止コマンドなしに自動で初期状態へ戻るように設計し、手を離すだけで安全に停止できるようにしました。',
        localcoder: 'Qwen2.5-CoderモデルをLoRAで直接ファインチューニングして韓国語対応のコードアシスタントに仕立て、OllamaでデプロイしたローカルAIエージェントです。FastAPIで認証とリクエスト制限を備えたWebサーバーを構築してGPUリソースがむやみに消費されないようにし、Cloudflare Tunnelで実際のドメインに接続することで、ローカル環境の外からもどこからでもアクセスできるサービスとして完成させました。',
        workout: 'SwiftUIで作ったiOSのワークアウト記録アプリです。トレーニング記録を筋肉ごとの回復速度で減衰させる疲労度モデルと、一つの種目が主動筋・協働筋に与える刺激を重みで分解するマッピングエンジンを自分で設計し、「今どの部位がどれだけ疲れているか」を人体図で表示します。ホーム・ロック画面ウィジェットとDynamic Islandでアプリを開かなくても回復状態を確認でき、InBodyのCSVを取り込んで体組成の変化を4象限で分析できるようにしました。外部ライブラリを使わず純正のAppleフレームワークのみで実装しており、SwiftUIとアプリアーキテクチャを自分の手で学ぶための学習用プロジェクトとして制作しました。',
        portfolio: '今ご覧になっているこのサイトです。Reactで一から作ったシングルページポートフォリオで、韓国語・英語・日本語の3言語をリアルタイムに切り替える多言語システムと、セクション単位のフルスクリーンスクロールを実装しました。プロジェクト・スキル・資格のデータをコンポーネントから分離して管理できるよう設計し、完成したサイトはCloudflare Pagesにデプロイして実際のドメインで24時間運用しています。',
      },
      captions: {
        todayappHome: '現在地を基準に、周辺の観光地を距離順におすすめします。',
        todayappCategory: 'グルメ・ドライブ・文化などのカテゴリを選ぶと、おすすめ結果が変わります。',
        todayappLocation: 'GPS座標を緯度・経度の範囲と照合して現在の地域を判別します。',
        todayappActiveRoom: '最近やり取りがあった場所には、活発なチャットルームのバッジが表示されます。',
        todayappChatRoom: '同じ場所を選んだユーザーが集まるチャットルームと、リアルタイムの参加者数です。',
        todayappChatSend: 'メッセージは全参加者の画面にリアルタイムで反映されます。',
        todayappEmailVerify: 'メール認証リンクの送信後、残り時間をリアルタイムで表示します。',
        todayappProfile: 'ログイン中のユーザーのニックネームとアカウント情報を確認できます。',
        workoutHome: '今週不足している部位を分析し、今日のおすすめプランを表示します。',
        workoutPlanSelect: '空のプランでその場で始めるか、保存済みのプランを選んで運動を開始します。',
        workoutFatigueMap: '筋肉ごとの回復速度で減衰させた疲労度を、人体図の部位ごとに表示します。',
        workoutVolumeRadar: '期間ごとの部位別トレーニングボリュームをレーダーチャートで比較します。',
        workoutSession: 'セットごとに重量・回数を記録し、リアルタイムタイマーで休憩時間を管理します。',
        workoutAiCoach: '種目ごとの正しいフォーム、よくあるミス、テンポ・休憩の目安をAIコーチが教えてくれます。',
        workoutInbodyHistory: 'InBodyのCSVを読み込み、体重・骨格筋・体脂肪の変化を日付ごとに記録します。',
        workoutInbodyCoach: '直近の測定値の変化を分析し、次の方向性を提案するAIコーチのコメントです。',
      },
    },
    contact: {
      label: 'Contact',
      title: 'お問い合わせ',
      intro: '新しい機会やコラボレーションのご提案、いつでも歓迎です。',
      email: 'メール',
      copied: 'コピーしました!',
      github: 'GitHub',
    },
    footer: {
      copyright: '© 2026 Oh Seongwon. All rights reserved.',
      email: 'メール',
    },
    chatbot: {
      windowTitle: 'OSW Bot',
      greeting: 'こんにちは!Oh Seongwonについて気になることを聞いてください。',
      placeholder: 'メッセージを入力してください...',
      send: '送信',
      defaultReply: 'まだ学習中のチャットボットなので正確に答えられませんでした。もうすぐ賢くなります!',
      scriptedReplies: [
        {
          keywords: ['名前', '誰'],
          reply: '私はOh Seongwonです。コンピュータ電子工学を専攻する学生エンジニアです。',
        },
        {
          keywords: ['プロジェクト'],
          reply: 'Arduino/Raspberry PiベースのIoTプロジェクト、Reactのウェブプロジェクト、AIプロジェクトを行いました。下のProjectsセクションをご覧ください!',
        },
        {
          keywords: ['技術', 'スキル', 'skill'],
          reply: 'Frontend、AI、Embedded Systems、Database & Backend、Cloudなど様々な技術を扱っています。Skillsセクションをご覧ください!',
        },
        {
          keywords: ['連絡', 'contact', 'メール'],
          reply: 'ContactセクションでメールとGitHubのリンクを確認できます。',
        },
      ],
    },
  },
};
